import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Product, ProductName } from "@zp-models/product";

@Component({
  selector: "app-advice-footer",
  templateUrl: "./advice-footer.component.html",
  imports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdviceFooterComponent {
  @Input() isMobileView = false;
  @Input() advicedProduct: Product;
  @Output() orderProduct = new EventEmitter<ProductName>();
}
